import { ExacareFeature, FeatureFlagService } from '@/utils/featureFlagService';

import { useGetFacilitySettingValue } from './useGetFacilitySettingValue';

export function useIsScreenerLeadWaitlistEnabled(): boolean {
  const { value: waitlistEnabled } =
    useGetFacilitySettingValue('waitlist_enabled');

  const featureFlagEnabled = FeatureFlagService.isEnabled(
    ExacareFeature.CRM_SCREENER_LEAD_WAITLIST
  );

  return featureFlagEnabled && waitlistEnabled === 'enabled';
}
